import { useCheckLoadedAndShow } from '../hooks/useCheckLoadedAndShow';
export var LIBERTY_TAX_FINAL_DEST_REGEXP = /https:\/\/clientportal\.libertytax\.net\/home/;
export function useLibertyTax() {
    useCheckLoadedAndShow();
}
